
import { api as reportingApi } from "./reportingService";

export const getAccessLog = (query) => {
    return reportingApi("GET", "events?" + query ,null);
    
  };